<template>
  <div class="background-container" @click="GotoNavView">
    <div class="text-container">
      <div class="title-container">
        <p> 为了营造良好的学习贯彻</p>
<p>民族团结进步促进法的氛围</p>
<p>省民宗委联合华声在线推出网络答题H5</p>
<p>邀请各位网友参与答题</p>
<p>一起在法治轨道上</p>
<p>推动民族团结进步事业高质量发展</p>
      </div>
    </div>

    <div class="button-spacer"></div>
    <div class="next-button" @click="GotoNavView">开始答题</div>

  </div>
</template>

<script setup>
  	import {
		useRouter
	} from 'vue-router'

	const router = useRouter()
	
// @ is an alias to /src
const GotoNavView = async () => {
  // 尝试播放音乐
  if (window.playBgMusic && typeof window.playBgMusic === 'function') {
    await window.playBgMusic()
  }
  
  // 跳转到导航页面
  router.push({
    path: '/question',
  })
}
</script>

<style lang="scss" scoped>

.background-container {
  /* 设置背景图 */
  background-image: url('../assets/bg.png');
  background-size: 100% 100%;
  background-position: center;
  background-repeat: no-repeat;
  position: relative; /* 关键：作为定位父级 */
  min-height: 100vh; /* 使用 min-height 确保覆盖全屏且随内容增长 */
  width: 100%; /* 根据需求调整宽度 */
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 380px;
  box-sizing: border-box;
}


.text-container {
  width: calc(100% - 144px); /* 左右各留 72px，总共减去 144px */
  height: 325px;
  background-color: rgba(255, 237, 200, 0.1); /* 使用 rgba 代替 opacity，确保文字不透明 */
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.title-container {
  width: 453px;
  font-family: FZLTHK--GBK1-0;
  font-size: 26px;
  font-weight: bold;
  line-height: 44px;
  color: #ffffff; /* 修改为深红色，增加对比度 */
  text-align: center; /* 文字居中 */
}

.button-spacer {
  height: 0px; /* 将按钮向上移动20px，原先是20px现在是0px */
}

.next-button{
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  bottom: 60px;
	width: 398px;
	height: 74px;
	background-color: #f6db91;
	border-radius: 37px;
	font-family: MicrosoftYaHei-Bold;
	font-size: 36px;
	font-weight: normal;
	line-height: 36px;
	letter-spacing: 4px;
	color: #d7461e;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

</style>